<template>
    <v-sheet class="d-flex justify-center align-center flex-column" height="100%">
        <img src="@/assets/logo-big.svg" alt="404" />
        <div class="text-h1 pa-4 font-weight-bold">404</div>
        <div class="text-secondary text-h5">Page Not Found</div>
    </v-sheet>
</template>
<script setup lang="ts"></script>
